"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleClick = exports.handleIcon = exports.handleText = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material


var displayWarning = function displayWarning(props, action) {
  return props.displayModal(true, _react.default.createElement(_index.UnsavedMessage, {
    primaryAction: action
  }));
};

var handleOperationText = function handleOperationText(operation) {
  switch (operation) {
    case 'save':
      return "Saving ...";

    case 'discard':
      return "Discarding ...";

    case 'delete':
      return "Deleting ...";

    case 'create':
      return "Creating ...";

    case 'run':
      return "Running ...";

    case 'download':
      return "Downloading ...";

    case 'send':
      return "Sending ...";

    case 'load':
      return "Loading ...";

    case 'link':
      return "Linking ...";

    case 'upload':
      return "Uploading";

    default:
      return "Processing ...";
  }
};

var handleText = function handleText(processing, operation, text) {
  return processing ? handleOperationText(operation) : text;
};

exports.handleText = handleText;

var handleIcon = function handleIcon(props) {
  if (props.removeLoaderIcon) return;
  return props.processing ? _react.default.createElement(_index.Loader, null) : !!props.icon ? _react.default.createElement(_index.Icon, {
    name: props.icon,
    style: props.iconStyle
  }) : null;
};

exports.handleIcon = handleIcon;

var handleClick = function handleClick(props, e) {
  // prevent default action on click
  e.preventDefault(); // if we have a handler passed as a prop execute it (make sure this is FIRST to execute for things like state changes)

  if (props.handleClick) props.handleClick(e); // handle different link type cases

  switch (props.type) {
    case 'modal':
      props.action === false ? props.displayModal(false) : props.displayModal(true, props.action);
      break;

    case 'custom':
      break;

    case 'email':
      window.open(props.action, '_self');
      break;

    case 'action':
      if (props.action) props.action();
      break;

    case 'action_route':
      if (props.editMode) {
        displayWarning(props, props.action);
        return;
      }

      if (props.action) props.action();
      break;

    case 'scroll':
      // action = ref in this case
      // scroll to specific ref (DOM element)
      var domEl = typeof props.action === 'string' ? document.querySelector(props.action) : props.action;
      window.scrollTo(0, domEl.offsetTop);
      break;

    case 'external':
      if (props.editMode) {
        displayWarning(props, function () {
          return window.open(props.action);
        });
        return;
      }

      window.open(props.action);
      break;

    case 'internal':
      if (props.editMode) {
        displayWarning(props, function () {
          return props.moveToPage(props.action);
        });
        return;
      }

      props.moveToPage(props.action);
      break;

    default:
      break;
  }
};

exports.handleClick = handleClick;